import { Tooltip, TooltipPlacement } from '@sequencehq/core-components'
import { ReactNode } from 'react'
import { NAVIGATION_ANIMATION } from 'components/NavigationV3/constants/animation'

interface NavTooltipProps {
  label: string
  children: ReactNode
  isDisabled?: boolean
  placement?: TooltipPlacement
}

/**
 * A standardized tooltip component for navigation items when collapsed
 */
export const NavTooltip = ({
  label,
  children,
  isDisabled = false,
  placement = 'right'
}: NavTooltipProps) => {
  if (isDisabled) {
    return <>{children}</>
  }

  return (
    <Tooltip
      label={label}
      placement={placement}
      hasArrow
      openDelay={NAVIGATION_ANIMATION.TOOLTIP_DELAY}
    >
      {children}
    </Tooltip>
  )
}
